"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLumpSumPaymentMethodFactor = void 0;
const common_1 = require("../../../../../common");
const models_1 = require("../../../models");
function getLumpSumPaymentMethodFactor(options) {
    if (options.product !== models_1.InsuranceProduct.AssuranceSelect) {
        return common_1.getBillingFactor(options);
    }
    if (options.paymentPeriod === common_1.PaymentPeriod.Annually) {
        return common_1.getBillingFactor(options);
    }
    return options.billingType === common_1.BillingType.DirectBill ? 1 : common_1.getBillingFactor(options);
}
exports.getLumpSumPaymentMethodFactor = getLumpSumPaymentMethodFactor;
//# sourceMappingURL=get-lump-sum-payment-method-factor.js.map